import { NgModule }             from '@angular/core';
import { LoginComponent }       from './login.component';
import { AuthGuard }            from './auth-guard.service';
import { AuthService }          from './auth.service';
import { FormsModule }          from '@angular/forms';

@NgModule({
  imports: [ FormsModule ],
  declarations: [ LoginComponent ],
  providers: [ AuthGuard, AuthService ]
})

export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts